import { lazy, Suspense } from 'react';
import type { CommonProps } from '@/@types/common';
import { LayoutType } from '@/@types/theme';
import { LAYOUT_COLLAPSIBLE_SIDE } from '@/constants/theme.constant';
import Loading from '@/components/shared/Loading';
import type { LazyExoticComponent, JSX } from 'react';

type Layouts = Record<
  string,
  LazyExoticComponent<<T extends CommonProps>(props: T) => JSX.Element>
>;

interface PostLoginLayoutProps extends CommonProps {
  layoutType: LayoutType;
}

const layouts: Layouts = {
  [LAYOUT_COLLAPSIBLE_SIDE]: lazy(() => import('./components/CollapsibleSide')),
};

const PostLoginLayout = ({
  layoutType = LAYOUT_COLLAPSIBLE_SIDE,
  children,
}: PostLoginLayoutProps) => {
  const AppLayout = layouts[layoutType] ?? layouts[Object.keys(layouts)[0]];

  return (
    <Suspense
      fallback={
        <div className="flex h-[100vh] flex-auto flex-col">
          <Loading loading={true} />
        </div>
      }
    >
      <AppLayout>{children}</AppLayout>
    </Suspense>
  );
};

export default PostLoginLayout;
